var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { id: "Icone Portabilidade" } }, [
        _c("path", {
          attrs: {
            id: "Mask",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M11.3334 5.33359H2.66669C2.29869 5.33359 2.00002 5.03559 2.00002 4.66692C2.00002 4.29826 2.29869 4.00026 2.66669 4.00026H11.388L10.3494 3.19359C10.0587 2.96759 10.006 2.54826 10.232 2.25826C10.458 1.96692 10.8774 1.91426 11.1674 2.14026L13.742 4.14026C13.9067 4.26759 14.0014 4.46426 14 4.67292C13.9987 4.88026 13.9 5.07559 13.7334 5.20026L11.0667 7.20026C10.9467 7.29026 10.806 7.33359 10.6674 7.33359C10.4647 7.33359 10.264 7.24159 10.1334 7.06692C9.91269 6.77226 9.97202 6.35426 10.2667 6.13359L11.3334 5.33359ZM4.66668 10.0003H13.3333C13.7013 10.0003 14 10.2983 14 10.6669C14 11.0356 13.7013 11.3336 13.3333 11.3336H4.61201L5.65068 12.1403C5.94135 12.3663 5.99401 12.7856 5.76801 13.0756C5.63668 13.2449 5.44001 13.3336 5.24135 13.3336C5.09801 13.3336 4.95401 13.2883 4.83268 13.1936L2.25801 11.1936C2.09335 11.0663 1.99868 10.8696 2.00001 10.6609C2.00135 10.4536 2.10001 10.2583 2.26668 10.1336L4.93335 8.13359C5.22868 7.91292 5.64601 7.97226 5.86668 8.26692C6.08735 8.56159 6.02801 8.97959 5.73335 9.20026L4.66668 10.0003Z",
            fill: _vm.color
          }
        }),
        _c(
          "mask",
          {
            staticStyle: { "mask-type": "luminance" },
            attrs: {
              id: _vm.maskId,
              maskUnits: "userSpaceOnUse",
              x: "2",
              y: "2",
              width: "12",
              height: "12"
            }
          },
          [
            _c("path", {
              attrs: {
                id: "Mask_2",
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d:
                  "M11.3334 5.33359H2.66669C2.29869 5.33359 2.00002 5.03559 2.00002 4.66692C2.00002 4.29826 2.29869 4.00026 2.66669 4.00026H11.388L10.3494 3.19359C10.0587 2.96759 10.006 2.54826 10.232 2.25826C10.458 1.96692 10.8774 1.91426 11.1674 2.14026L13.742 4.14026C13.9067 4.26759 14.0014 4.46426 14 4.67292C13.9987 4.88026 13.9 5.07559 13.7334 5.20026L11.0667 7.20026C10.9467 7.29026 10.806 7.33359 10.6674 7.33359C10.4647 7.33359 10.264 7.24159 10.1334 7.06692C9.91269 6.77226 9.97202 6.35426 10.2667 6.13359L11.3334 5.33359ZM4.66668 10.0003H13.3333C13.7013 10.0003 14 10.2983 14 10.6669C14 11.0356 13.7013 11.3336 13.3333 11.3336H4.61201L5.65068 12.1403C5.94135 12.3663 5.99401 12.7856 5.76801 13.0756C5.63668 13.2449 5.44001 13.3336 5.24135 13.3336C5.09801 13.3336 4.95401 13.2883 4.83268 13.1936L2.25801 11.1936C2.09335 11.0663 1.99868 10.8696 2.00001 10.6609C2.00135 10.4536 2.10001 10.2583 2.26668 10.1336L4.93335 8.13359C5.22868 7.91292 5.64601 7.97226 5.86668 8.26692C6.08735 8.56159 6.02801 8.97959 5.73335 9.20026L4.66668 10.0003Z",
                fill: "white"
              }
            })
          ]
        ),
        _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
          _c("g", { attrs: { id: "🎨 Color" } }, [
            _c("rect", {
              attrs: { id: "Base", width: "16", height: "16", fill: _vm.color }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }